<template>
    <div class="bg-white w-full shadow rounded-lg mt-3 p-6">
        <div class="md:flex items-center">
            <div
                class="w-20 h-20 bg-face-haze rounded flex flex-shrink-0 items-center justify-center"
            >
                <svg
                    aria-hidden="true"
                    role="img"
                    width="64"
                    height="64"
                    preserveAspectRatio="xMidYMid meet"
                    viewBox="0 0 24 24"
                >
                    <g stroke-width="1.5" fill="none">
                        <path
                            d="M10 9H6"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        ></path>
                        <path
                            d="M15.5 11a2.5 2.5 0 1 1 0-5a2.5 2.5 0 0 1 0 5z"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        ></path>
                        <path
                            d="M6 6h3"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        ></path>
                        <path
                            d="M18 18l-4.5-3l-2.5 2l-5-4"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        ></path>
                        <path
                            d="M3 20.4V3.6a.6.6 0 0 1 .6-.6h16.8a.6.6 0 0 1 .6.6v16.8a.6.6 0 0 1-.6.6H3.6a.6.6 0 0 1-.6-.6z"
                            stroke="currentColor"
                        ></path>
                    </g>
                </svg>
            </div>
            <div class="md:ml-6 md:mt-0 mt-4 w-full">
                <div class="flex items-center justify-between">
                    <p class="text-xl font-semibold leading-5 text-gray-800">
                        {{ props.report?.name ?? "No Name" }}
                    </p>
                </div>
                <p class="text-sm pt-3 text-gray-600">
                    {{ props.report?.description ?? "No Description" }}
                </p>
                <div class="mt-4 flex items-center space-x-4">
                    <span class="inline-flex text-face-red"
                        ><svg
                            aria-hidden="true"
                            role="img"
                            class="fill-current"
                            width="24"
                            height="24"
                            preserveAspectRatio="xMidYMid meet"
                            viewBox="0 0 24 24"
                        >
                            <path
                                d="M6 13h12v-2H6M3 6v2h18V6M10 18h4v-2h-4v2z"
                            ></path></svg
                    ></span>
                    <p
                        v-for="filter in props.report?.filters"
                        class="text-xs leading-3 text-gray-600"
                    >
                        #{{ filter.name }}
                    </p>
                </div>
            </div>
        </div>
        <div class="md:flex items-center justify-between mt-6">
            <div class="flex items-center">
                <div class="inline-flex space-x-4 items-center">
                    <span class="font-bold text-xs text-black">Active</span>
                    <ToggleWithIcon
                        @update="handleStatusUpdate"
                        :active="props.report?.is_active ?? false"
                    />
                </div>
                <button
                    role="button"
                    aria-label="Like button"
                    class="hidden flex items-center ml-3 p-1 border rounded-sm border-gray-200 cursor-pointer"
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.74648 11.3487L5.94714 9.82199C5.58168 10.2127 5.10713 10.4844 4.58519 10.6019C4.06325 10.7194 3.51804 10.6771 3.02043 10.4807C2.52281 10.2842 2.09579 9.94263 1.79486 9.50029C1.49393 9.05795 1.33301 8.53532 1.33301 8.00033C1.33301 7.46533 1.49393 6.9427 1.79486 6.50036C2.09579 6.05802 2.52281 5.71643 3.02043 5.51997C3.51804 5.32351 4.06325 5.28127 4.58519 5.39874C5.10713 5.5162 5.58168 5.78795 5.94714 6.17866L8.74715 4.65199C8.58818 4.02271 8.66418 3.35705 8.9609 2.7798C9.25762 2.20254 9.75468 1.75331 10.3589 1.51633C10.9632 1.27934 11.6331 1.27086 12.2431 1.49248C12.8532 1.7141 13.3615 2.1506 13.6727 2.72017C13.9839 3.28973 14.0767 3.95325 13.9337 4.58636C13.7908 5.21946 13.4218 5.77868 12.896 6.1592C12.3702 6.53972 11.7236 6.7154 11.0775 6.65332C10.4315 6.59125 9.83021 6.29567 9.38648 5.82199L6.58648 7.34866C6.69395 7.77623 6.69395 8.22375 6.58648 8.65133L9.38581 10.178C9.82955 9.70432 10.4308 9.40874 11.0769 9.34666C11.723 9.28459 12.3695 9.46027 12.8953 9.84079C13.4211 10.2213 13.7901 10.7805 13.9331 11.4136C14.0761 12.0467 13.9832 12.7103 13.672 13.2798C13.3608 13.8494 12.8525 14.2859 12.2425 14.5075C11.6324 14.7291 10.9625 14.7206 10.3583 14.4837C9.75402 14.2467 9.25695 13.7974 8.96023 13.2202C8.66352 12.6429 8.58751 11.9773 8.74648 11.348V11.3487ZM3.99981 9.33333C4.35343 9.33333 4.69257 9.19285 4.94262 8.9428C5.19267 8.69275 5.33315 8.35362 5.33315 7.99999C5.33315 7.64637 5.19267 7.30723 4.94262 7.05718C4.69257 6.80714 4.35343 6.66666 3.99981 6.66666C3.64619 6.66666 3.30705 6.80714 3.057 7.05718C2.80695 7.30723 2.66648 7.64637 2.66648 7.99999C2.66648 8.35362 2.80695 8.69275 3.057 8.9428C3.30705 9.19285 3.64619 9.33333 3.99981 9.33333ZM11.3331 5.33333C11.6868 5.33333 12.0259 5.19285 12.276 4.9428C12.526 4.69275 12.6665 4.35362 12.6665 3.99999C12.6665 3.64637 12.526 3.30723 12.276 3.05718C12.0259 2.80714 11.6868 2.66666 11.3331 2.66666C10.9795 2.66666 10.6404 2.80714 10.3903 3.05718C10.1403 3.30723 9.99981 3.64637 9.99981 3.99999C9.99981 4.35362 10.1403 4.69275 10.3903 4.9428C10.6404 5.19285 10.9795 5.33333 11.3331 5.33333ZM11.3331 13.3333C11.6868 13.3333 12.0259 13.1929 12.276 12.9428C12.526 12.6928 12.6665 12.3536 12.6665 12C12.6665 11.6464 12.526 11.3072 12.276 11.0572C12.0259 10.8071 11.6868 10.6667 11.3331 10.6667C10.9795 10.6667 10.6404 10.8071 10.3903 11.0572C10.1403 11.3072 9.99981 11.6464 9.99981 12C9.99981 12.3536 10.1403 12.6928 10.3903 12.9428C10.6404 13.1929 10.9795 13.3333 11.3331 13.3333Z"
                            fill="#4B5563"
                        />
                    </svg>

                    <button
                        @click="share"
                        class="text-xs leading-3 text-gray-600 pl-1"
                    >
                        Share
                    </button>
                </button>
            </div>
            <p
                class="text-base font-semibold leading-none text-gray-600 md:mt-0 mt-4 inline-flex space-x-[20px]"
            >
                <button
                    @click="duplicate"
                    class="bg-purple-500 rounded-md px-10 py-2 shadow-lg shadow-purple-500/50 text-white font-bold text-sm"
                >
                    Duplicate
                </button>
                <Link
                    class="bg-face-red rounded-md px-10 py-2 shadow-lg shadow-face-red/50 text-white font-bold text-sm"
                    type="button"
                    @click="handleRemove"
                    >Delete
                </Link>
                <Link
                    class="bg-indigo-500 rounded-md px-10 py-2 shadow-lg shadow-indigo-500/50 text-white font-bold text-sm"
                    :href="url"
                    type="button"
                    >Open
                </Link>
            </p>
        </div>
    </div>
</template>
<script setup>
import { Link } from "@inertiajs/inertia-vue3";
import ToggleWithIcon from "@/Shared/ToggleWithIcon";
import { computed } from "vue";

const props = defineProps({ report: Object });
const emit = defineEmits(["remove"]);

const handleStatusUpdate = async (status) => {
    await axios.patch(`/reports/custom/${props.report?.id}/status`, { status });
};

const url = computed(() => {
    if (props.report?.query_type === "weekly") {
        return `/reports/custom/weekly/${props.report?.id}`;
    }
    return `/reports/custom/${props.report?.id}`;
});

const duplicate = async () => {
    try {
        await axios.post(`/reports/custom/${props.report?.id}/duplicate`);
        window.location.reload();
    } catch (e) {
        Swal.fire({
            title: "Error",
            text: e.response.data.message,
            icon: "error",
            confirmButtonText: "Ok",
        });
    }
};

const share = () => {};
const handleRemove = async () => {
    try {
        await axios.delete(`/reports/custom/${props.report.id}`);
        emit("remove", props.report.id);
        window.location.reload();
    } catch (e) {
        Swal.fire({
            title: "Error",
            text: e.response.data.message,
            icon: "error",
            confirmButtonText: "Ok",
        });
    }
};
</script>
